/**
 * @flow
 * @relayHash f408e68ba7ff5f7993ff16a95e833cef
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateWidgetDataInput = {
  userId: string,
  widgetId: string,
  data: string,
  clientMutationId?: ?string,
};
export type UpdateWidgetDataMutationVariables = {|
  input: UpdateWidgetDataInput
|};
export type UpdateWidgetDataMutationResponse = {|
  +updateWidgetData: ?{|
    +widget: ?{|
      +data: ?string
    |}
  |}
|};
export type UpdateWidgetDataMutation = {|
  variables: UpdateWidgetDataMutationVariables,
  response: UpdateWidgetDataMutationResponse,
|};
*/


/*
mutation UpdateWidgetDataMutation(
  $input: UpdateWidgetDataInput!
) {
  updateWidgetData(input: $input) {
    widget {
      data
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateWidgetDataInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "UpdateWidgetDataInput!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "data",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "UpdateWidgetDataMutation",
  "id": null,
  "text": "mutation UpdateWidgetDataMutation(\n  $input: UpdateWidgetDataInput!\n) {\n  updateWidgetData(input: $input) {\n    widget {\n      data\n      id\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "UpdateWidgetDataMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "updateWidgetData",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateWidgetDataPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "widget",
            "storageKey": null,
            "args": null,
            "concreteType": "Widget",
            "plural": false,
            "selections": [
              v2
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "UpdateWidgetDataMutation",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "updateWidgetData",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateWidgetDataPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "widget",
            "storageKey": null,
            "args": null,
            "concreteType": "Widget",
            "plural": false,
            "selections": [
              v2,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '779999ee36248fb05842ed1964087919';
module.exports = node;



// WEBPACK FOOTER //
// ./src/js/mutations/__generated__/UpdateWidgetDataMutation.graphql.js